// extracted by mini-css-extract-plugin
module.exports = {"PaypalPastDue":"_1D45q","alertWindow":"_1uDdC","dec":"_3jZ3e","reminder":"_3md9N","checkbox":"_2DgIl","btnFooter":"ZFSd1","goBtn":"_3fGKN","stayBtn":"_3ZTS7"};